document.addEventListener("DOMContentLoaded", () => {
  const promoBar = document.querySelector(".js-promo-bar");
  const topEl = document.querySelector(".js-top");
  const topContent = document.querySelector(".js-top-content");
  const fixedHeader = document.querySelector(".js-fixed-header");

  if (!promoBar || !topEl || !topContent || !fixedHeader) return;

  const topHeight = topEl.offsetHeight;
  const promoHeight = promoBar.offsetHeight;

  topEl.style.height = `${topHeight}px`;

  topContent.style.position = "absolute";
  topContent.style.top = "0";
  topContent.style.left = "0";
  topContent.style.right = "0";
  topContent.style.zIndex = "110";
  fixedHeader.style.zIndex = "110";

  const onScroll = () => {
    if (window.scrollY > promoHeight) {
      fixedHeader.style.position = "fixed";
      fixedHeader.style.top = "0";
      fixedHeader.style.left = "0";
      fixedHeader.style.right = "0";
      fixedHeader.style.width = "100%";
    } else {
      fixedHeader.style.position = "";
      fixedHeader.style.top = "";
      fixedHeader.style.left = "";
      fixedHeader.style.right = "";
      fixedHeader.style.width = "";
    }
  };

  onScroll();
  window.addEventListener("scroll", onScroll);
});